import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* deleteSmartGroup({ payload: { id, onSuccess } }) {

  try {
    const { data } = yield call(fetch, { api: api.modifiers.smartgroup.remove, id });


    onSuccess && onSuccess();
    yield put(actions.deleteSmartGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteSmartGroupFailed,
      endpoint: api.modifiers.smartgroup.remove.url
    });
  }
}

export const deleteSmartGroupSaga = takeEvery(types.DELETE_SMART_GROUP_REQUEST, deleteSmartGroup);